import React, { Component } from 'react';

import { Table, Popconfirm } from 'antd';

class MpaParkinglocationTable extends Component {

  state = {
    children: []
  }

  columns = [{
    title: 'Lokalita',
    dataIndex: 'ParkingLocationName',
    key: 'ParkingLocationName',    
  }, {
    title: 'Externí identifikátor zóny',
    dataIndex: 'ExtID',
    key: 'ExtID',
    width: '50%',    
  }, {
    title: 'Akce',
    key: 'Action',
    width: 100,
    render: (text, record) => (        
      <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
          this.props.onRemoveRow(record.id)
        }} okText="Ano" cancelText="Ne">
        <a onClick={(e) => { e.preventDefault(); }}>Smazat</a>      
      </Popconfirm>
    ),
  }]

  render() {    
    return (    
      <Table         
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns} 
        dataSource={this.props.data} 
        style={{border: '0px'}} />
    );
  }
}

export default MpaParkinglocationTable;


// WEBPACK FOOTER //
// ./src/components/MpaParkinglocationTable.js